import { ReactNode } from "react";

interface ModernThemeProps {
  children: ReactNode;
  themeColor: string;
  headingColor: string;
  buttonColor: string;
}

export default function ModernTheme({ children, themeColor, headingColor, buttonColor }: ModernThemeProps) {
  return (
    <div className="modern-theme" style={{ background: 'linear-gradient(to bottom, #f8fafc, #ffffff)', minHeight: '100vh' }}>
      <style>{`
        .modern-theme {
          --theme-color: ${themeColor};
          --heading-color: ${headingColor};
          --button-color: ${buttonColor};
          background: linear-gradient(to bottom, #f8fafc, #ffffff) !important;
        }
        
        /* Modern gradient backgrounds */
        .modern-theme .bg-gradient-to-br {
          background: linear-gradient(135deg, #1e293b, #334155) !important;
          position: relative !important;
        }
        
        .modern-theme .bg-gradient-to-br::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, transparent 30%, ${themeColor}15 100%);
          pointer-events: none;
        }
        
        /* Modern cards with border accent */
        .modern-theme .bg-white {
          background: linear-gradient(to right, white, #f9fafb) !important;
          border-radius: 1rem !important;
          border-left: 4px solid ${themeColor} !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
          transition: all 0.3s ease !important;
        }
        
        .modern-theme .bg-white:hover {
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
          border-left-width: 6px !important;
          transform: translateX(4px) !important;
        }
        
        /* Modern buttons with elevation */
        .modern-theme button,
        .modern-theme .btn {
          background: ${buttonColor} !important;
          color: white !important;
          padding: 0.875rem 1.75rem !important;
          border-radius: 0.5rem !important;
          font-weight: 600 !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
          border: none !important;
        }
        
        .modern-theme button:hover,
        .modern-theme .btn:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2) !important;
        }
        
        /* Enhanced shadows */
        .modern-theme .shadow-xl,
        .modern-theme .shadow-2xl {
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
        }
        
        /* Typography */
        .modern-theme h1, 
        .modern-theme h2, 
        .modern-theme h3 {
          font-weight: 700 !important;
          letter-spacing: -0.025em !important;
        }
        
        /* Smooth animations */
        .modern-theme * {
          transition: all 0.2s ease !important;
        }
      `}</style>
      {children}
    </div>
  );
}
